import React from 'react';
import { motion } from 'framer-motion';
import { ZapIcon } from 'lucide-react';
import { handleAddToCart } from '../utils/metaPixel';
export function OfferCTA() {
  return <section id="offer" className="py-16 bg-dark border-t border-surfaceHighlight relative overflow-hidden" data-id="element-170">
      <div className="absolute inset-0 bg-crosshair opacity-10" data-id="element-171"></div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 text-center" data-id="element-172">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} data-id="element-173">
          <h2 className="font-display text-2xl md:text-3xl font-extrabold text-white mb-8 uppercase tracking-tight" data-id="element-174">
            ¿Listo para operar como un{' '}
            <span className="text-primary text-glow" data-id="element-175">profesional?</span>
          </h2>

          <a href="https://tradingsniperpanel.com/" target="_blank" rel="noopener noreferrer" onClick={handleAddToCart} className="inline-flex px-10 py-5 bg-primary/10 text-primary border border-primary font-display font-bold text-xl rounded-sm hover:bg-primary hover:text-dark transition-all duration-300 box-glow uppercase tracking-wider items-center justify-center gap-3 group" data-id="element-176">
            Ver Planes
            <ZapIcon className="w-6 h-6 group-hover:scale-110 transition-transform" data-id="element-177" />
          </a>
        </motion.div>
      </div>
    </section>;
}